export default "__VITE_ASSET__D65HgdV1__"